import React,{Component} from 'react';
import jsonp from "jsonp"

import Wrapper from '../Wrapper';

import './Signup.less';

class Signup extends Component{
  constructor(){
    super();
    this.state = {
      loading: false,
      status: null,
      msg: null
    }
    this.url = "//skacore.us6.list-manage.com/subscribe/post?u=f230d81c21&amp;id=1727377779";
  }

  submit = (e) => {
    e.preventDefault();
    const email = this.email.value;

    let url = this.url.replace('/post?', '/post-json?');

    if (!this.email.value || this.email.value.length < 5 || this.email.value.indexOf("@") === -1) {

       this.setState({
         status: "error",
         msg: 'Keine gültige Emailadresse!'
       })

       return
    }else{
      this.setState({
        loading: true
      })
    }

    url = url + `&EMAIL=${email}`;


    jsonp(url, {
        param: "c"
      }, (err, data) => {
        if (err) {
          console.log(err);
          this.setState({
            status: 'error',
            msg: err,
            loading: false
          })
        } else if (data.result !== 'success') {
          console.log(data.msg);
          this.setState({
            status: 'error',
            msg: data.msg,
            loading: false
          })
        } else {
          console.log(data.msg);
          this.setState({
            status: 'success',
            msg: data.msg,
            loading: false
          })
        }
      })

  }

  render(){
    const {res} = this.props;
    const {loading,msg,status} = this.state;
    return (
      <Wrapper title="Jetzt anmelden" style={{background:`url(/img/secondary_bg.jpg)`}} res={res}>
      <div className='signup-wrapper'>
        <div className={`newsletter ${res}`}>
        <h3>Newsletter</h3>
        {
           status && <div>{msg}<br /><br /></div>
        }
          {
            status !== 'success' &&
            <form className='action' action={this.url} method="post" onSubmit={this.submit}>
              <input type="text" className={status == 'error' ? "email email-error" : "email"} placeholder="Deine Email Adresse" ref={_ => this.email = _} />
              <input className='signup-submit' type="submit" value={loading ? "Senden..." : "Anmelden"} />
              <div style={{position: 'absolute', left: -5000}} aria-hidden="true"><input type="text" name="b_f230d81c21_1727377779" tabIndex="-1" value="" /></div>
            </form>
        }
          Jetzt für den Newsletter eintragen und regelmäßig über neue Konzert-Termine und Releases informiert werden
        </div>
        <div className={`whatsapp ${res}`}>
        <h3>Streetteam</h3>
        <div className='action' style={{justifyContent:'center'}}>
          <img className="whatsapp-logo" src="/img/netzwerke/whatsapp.svg" />
          <div className="tel">+49 151 61259104</div>
        </div>
          Du willst Mitglied im unserem Streetteam werden? Dann schicke uns deinen Namen, Adresse und E-Mail-Adresse per WhatsApp
        </div>
      </div>
      </Wrapper>
    )
  }
}

export default Signup



// WEBPACK FOOTER //
// ./src/components/sections/Signup.js